module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addSource
    }
  }, [_vm._v("新增来源")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.checkMemberTags
    }
  }, [_vm._v("选择会员标签")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "批量打标签会替换所有标签，不会做合并，请慎重操作",
      "type": "warning",
      "closable": false
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "placeholder": "搜索"
    },
    model: {
      value: (_vm.searchTxt),
      callback: function($$v) {
        _vm.searchTxt = $$v
      },
      expression: "searchTxt"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.getSourcesLists()
      }
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "multipleSourceTable",
    attrs: {
      "data": _vm.dataList,
      "row-key": _vm.getRowKeys,
      "height": _vm.wheight - 210
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "label": "全选"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sourceId",
      "label": "来源ID",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sourceName",
      "label": "来源名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "wxAppId",
      "label": "第三方小程序AppId",
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.wxAppId || '-') + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sourceName",
      "label": "标签"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._l((scope.row.tagsId), function(item, index) {
          return _c('el-tag', {
            key: index
          }, [_vm._v(_vm._s(_vm.AllcheckTags[item]))])
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "创建时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [
          [_vm._v("\n          " + _vm._s(_vm._f("datetime")(scope.row.created, 'yyyy-MM-dd hh:mm:ss')) + "\n        ")]
        ]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-padded view-flex view-flex-center"
  }, [(_vm.total_count > _vm.pageLimit) ? _c('div', {
    staticClass: "f_r"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "total": _vm.total_count,
      "page-size": _vm.pageLimit
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.form.source_id ? '编辑来源' : '添加来源',
      "visible": _vm.dialogVisible,
      "show-close": false,
      "close-on-click-modal": false
    }
  }, [_c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.form,
      "label-width": "140px"
    }
  }, [(!_vm.tagdialogVisible) ? _c('el-form-item', {
    attrs: {
      "label": "来源名称",
      "prop": "source_name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "填写来源名称"
    },
    model: {
      value: (_vm.form.source_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "source_name", $$v)
      },
      expression: "form.source_name"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "frm-tips"
  }, [_vm._v("建议将来源名称命名为要使用的推广渠道的名称，方便理解与跟踪，例如：微信朋友圈广告")])], 1) : _vm._e(), _vm._v(" "), (!_vm.tagdialogVisible) ? _c('el-form-item', {
    attrs: {
      "label": "第三方小程序AppId",
      "prop": "wx_app_id"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "选填，如 wx5fbda51d446ddf0c"
    },
    model: {
      value: (_vm.form.wx_app_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "wx_app_id", $$v)
      },
      expression: "form.wx_app_id"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "frm-tips"
  }, [_vm._v("填写后可用于识别从该第三方小程序跳转进入的用户，来源ID将自动作为订单 source_id")])], 1) : _vm._e(), _vm._v(" "), (!_vm.tagdialogVisible) ? _c('el-form-item', {
    attrs: {
      "label": "会员标签",
      "prop": "source_name"
    }
  }, _vm._l((_vm.checktags), function(item, index) {
    return _c('el-tag', {
      key: index
    }, [_vm._v(_vm._s(item.tag_name))])
  }), 1) : _vm._e(), _vm._v(" "), (_vm.tagdialogVisible) ? _c('el-form-item', {
    attrs: {
      "label": "选中的来源",
      "prop": "source_name"
    }
  }, _vm._l((_vm.checkSource), function(item, index) {
    return _c('el-tag', {
      key: index
    }, [_vm._v(_vm._s(item.sourceName))])
  }), 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标签列表",
      "prop": "source_name"
    }
  }, [
    [_c('el-table', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.loading),
        expression: "loading"
      }],
      ref: "multipleTable",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.taglist,
        "tooltip-effect": "dark",
        "row-key": _vm.getTagRowKeys,
        "select-on-indeterminate": false
      },
      on: {
        "select": _vm.handleSelectChange,
        "select-all": _vm.handleSelectAll
      }
    }, [_c('el-table-column', {
      attrs: {
        "type": "selection",
        "reserve-selection": true,
        "width": "50"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "tag_id",
        "label": "id",
        "width": "60"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "tag_name",
        "label": "标签名称",
        "width": "300"
      }
    })], 1), _vm._v(" "), (_vm.tagcount > _vm.pageLimit) ? _c('div', {
      staticClass: "content-center content-top-padded"
    }, [_c('el-pagination', {
      attrs: {
        "layout": "prev, pager, next",
        "total": _vm.tagcount,
        "page-size": _vm.pageLimit
      },
      on: {
        "current-change": _vm.handleRelShopCurrentChange
      }
    })], 1) : _vm._e()]
  ], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), (_vm.tagdialogVisible) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitMemberTag
    }
  }, [_vm._v("确定")]) : _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("确定")])], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-06f1a8aa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06f1a8aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/wxapp/statistics/sourcemanagement/source_list.vue
// module id = 2442
// module chunks = 0